import * as React from 'react';
import { Props } from '../types/types';

import { Container, Row, Col } from 'react-bootstrap';
import { View, IconButton, rem } from '../libs/WebComponents';
import { usePopupStore } from '../store/popups';
import IconButtonShadow from '../Components/IconButtonShadow';
import { QuestionType } from '../store/questions';
import { DEV } from '../Constants';
import AnswersSelectList, { AnswerListItemType } from './AnswersSelectlist';


const QuestionAB = (props: Props) => {
   const [isValid, setIsValid] = React.useState(props.page.required ? false : true);
   const [allAnswers, setAllAnswers] = React.useState<AnswerListItemType[]>(props.page.answerslist && props.page.answerslist.length ? props.page.answerslist.map((answer: AnswerListItemType)=>({...answer, A: false, B: false, C: false})) : []);
   const { addPopup, removePopup } = usePopupStore();


   React.useEffect(()=>{
      props.setCanNext(isValid);
      props.setShowExplanationPage(()=>()=>props.showTip(props.page.question_type));

      return ()=>{
         props.setCanNext(true);
         props.setShowExplanationPage(null);
      }
   },[isValid]);

   const _removeAnswer = React.useCallback((value: string) => {
      const in_list = props.page.answerslist.find((answer: AnswerListItemType)=>(value===answer.value));

      if(!in_list)
      {
         //not a default answer so remove from list
         setAllAnswers((answers: AnswerListItemType[])=>answers.filter((answer: AnswerListItemType)=>answer.value!==value));
      }else{
         setAllAnswers((answers: AnswerListItemType[])=>answers.map((answer: AnswerListItemType)=>{
            if (answer.value===value) return {...answer, A: false, B: false, C: false};
            return answer;
         }));
      }
   }
   ,[allAnswers]);


   const _changeAnswers = React.useCallback((type: 'A' | 'B' | 'C', new_answers: AnswerListItemType[], added_answers: string[], removed_answers: string[]) => {

      let new_answers_list = allAnswers.map((answer: AnswerListItemType)=>{
         if (added_answers && added_answers.includes(answer.value)) return {...answer, [type]: true};
         if (removed_answers && removed_answers.includes(answer.value)) return {...answer, [type]: false};
         return answer;
      });

      if (new_answers.length>0) new_answers_list = [...new_answers_list, ...new_answers];

      setAllAnswers(new_answers_list);
   },[allAnswers]);

   const showAnswersPopup = (message: string, type: 'A' | 'B' | 'C') => {
      const uuid = addPopup({type:'fullscreen answers-list', closeButtonColor:'var(--color-white)', children: <AnswersSelectList closePopup={()=>removePopup(uuid)} allAnswers={allAnswers} message={message} type={type} changeAnswers={_changeAnswers} />});
   }

   React.useEffect(()=>{
      const valid = allAnswers.find((a)=>a.A || a.B || a.C) ? true : false;
      if (valid) {
         if (DEV) console.log('setAnswers', allAnswers)
         props.setAnswers({answers_ABC:[...allAnswers]});
      }
      if (props.page.required && valid!==isValid) setIsValid(valid);

   },[allAnswers]);

   React.useEffect(()=>{
      if (props.given_answers && Array.isArray(props.given_answers.answers_ABC))
      {
         setAllAnswers(props.given_answers.answers_ABC);
      }
   },[props.given_answers]);

   return (
      <Container>
         <Row className={'justify-content-center'}>
            <Col>
               <View className={'answer-boxes'}>
                  <View className={'answer-box'}>
                     <IconButtonShadow onPress={()=>showAnswersPopup('Wat vind jij negatief?', 'A')} name={'EmoticonMad'} size={rem(4)} iconSize={rem(3.5)} color={'var(--color-green)'} iconColor={'var(--color-purple-dark)'} shadow={'var(--color-purple-dark)'} />
                     <View className={'answers-list bg-white'}>
                        <ul>
                           {allAnswers.map((answer: AnswerListItemType)=>answer.A?<li className={'answers-list-item'} key={answer.value}><View>{answer.label}<IconButton name={'Close'} onPress={()=>_removeAnswer(answer.value)} size={rem(2.2)} iconSize={rem(2)} color={'var(--color-green)'}/></View></li>:null)}
                        </ul>
                        <View><IconButton onPress={()=>showAnswersPopup('Wat vind jij negatief?', 'A')} name={'Plus'} size={rem(2.2)} iconSize={rem(2.5)} color={'var(--color-green)'} iconColor={'var(--color-purple-dark)'} containerStyle={{alignSelf:'center'}}/></View>
                     </View>
                  </View>
                  <View className={'answer-box'}>
                     <IconButtonShadow onPress={()=>showAnswersPopup('Wat vind jij neutraal?', 'B')} name={'EmoticonNeutral'} size={rem(4)} iconSize={rem(3.5)} color={'var(--color-green)'} iconColor={'var(--color-purple-dark)'} shadow={'var(--color-purple-dark)'} />
                     <View className={'answers-list bg-white'}>
                        <ul>
                           {allAnswers.map((answer: AnswerListItemType)=>answer.B?<li className={'answers-list-item'} key={answer.value}><View>{answer.label}<IconButton name={'Close'} onPress={()=>_removeAnswer(answer.value)} size={rem(2.2)} iconSize={rem(2)} color={'var(--color-green)'}/></View></li>:null)}
                        </ul>
                        <View><IconButton onPress={()=>showAnswersPopup('Wat vind jij neutraal?', 'B')} name={'Plus'} size={rem(2.2)} iconSize={rem(2.5)} color={'var(--color-green)'} iconColor={'var(--color-purple-dark)'} containerStyle={{alignSelf:'center'}}/></View>
                     </View>
                  </View>
                  <View className={'answer-box'}>
                     <IconButtonShadow onPress={()=>showAnswersPopup('Wat vind jij positief?', 'C')} name={'EmoticonHappy'} size={rem(4)} iconSize={rem(3.5)} color={'var(--color-green)'} iconColor={'var(--color-purple-dark)'} shadow={'var(--color-purple-dark)'} />
                     <View className={'answers-list bg-white'}>
                        <ul>
                           {allAnswers.map((answer: AnswerListItemType)=>answer.C?<li className={'answers-list-item'} key={answer.value}><View>{answer.label}<IconButton name={'Close'} onPress={()=>_removeAnswer(answer.value)} size={rem(2.2)} iconSize={rem(2)} color={'var(--color-green)'}/></View></li>:null)}
                        </ul>
                        <View><IconButton onPress={()=>showAnswersPopup('Wat vind jij positief?', 'C')} name={'Plus'} size={rem(2.2)} iconSize={rem(2.5)} color={'var(--color-green)'} iconColor={'var(--color-purple-dark)'} containerStyle={{alignSelf:'center'}}/></View>
                     </View>
                  </View>
               </View>
            </Col>
         </Row>
      </Container>
   );
}


export default React.memo(QuestionAB);